import { render, staticRenderFns } from "./ExaminedStudent.vue?vue&type=template&id=7b23bd8e&scoped=true&"
import script from "./ExaminedStudent.vue?vue&type=script&lang=js&"
export * from "./ExaminedStudent.vue?vue&type=script&lang=js&"
import style0 from "./ExaminedStudent.vue?vue&type=style&index=0&id=7b23bd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23bd8e",
  null
  
)

export default component.exports